const getGradData = (credits) => {
  const days1 = ((220 - credits) / 3) * 7;
  const days2 = ((220 - credits) / 2) * 7;

  const date1 = new Date(new Date().setDate(new Date().getDate() + days1));
  const date2 = new Date(new Date().setDate(new Date().getDate() + days2));

  return { date1, date2 };
};

export default getGradData;
